import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import DcPage from "@/components/landing/dcv2/DcPage";
import { Button } from "@/components/ui/button";
import { SearchX, ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <DcPage>
      <section className="container py-24 md:py-32">
        <div className="text-center space-y-6 max-w-md mx-auto">
          <div className="mx-auto w-20 h-20 rounded-2xl bg-muted flex items-center justify-center mb-2">
            <SearchX className="h-10 w-10 text-muted-foreground" />
          </div>
          <div className="space-y-3">
            <h1 className="text-6xl font-extrabold tracking-tight">404</h1>
            <p className="text-lg text-foreground font-medium">Page not found</p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The page you're looking for doesn't exist or has been moved. Check the URL or head back to a known page.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 justify-center pt-4">
            <Button size="lg" asChild>
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Home
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/contact">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Contact Us
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </DcPage>
  );
};

export default NotFound;
